export default __webpack_public_path__ + "static/media/brp_logo.e8e0f5c7.svg";